import * as React from 'react';
import {Query} from 'react-apollo';

import gql from 'graphql-tag';

import type {
    Stages as StagesQuery,
    StagesVariables as StagesQueryVariables,
} from 'nutshell-graphql-types';

import {GraphQLSelect} from '../../../core/select/graphql-select';

import {getValidStagesForSelect} from './get-valid-stages-for-select';

export const SEND_UNTIL_LEAD_CLOSE_MAGIC_ID = 'UNTIL_CLOSE';
export const EXITS_STAGE_NEVER_MAGIC_ID = 'FOREVER';

type Props = {
    inputId?: string;
    stageId: string;
    stagesetId: string;
    onClearValue?: () => void;
    onChange: (newValue: any) => void;
    selectedId: string | null | undefined;
    includeUntilClose?: boolean;
    includeForever?: boolean;
};

// Stage properties we need specifically for this select input to
// figure out what data to display to the user.
const STAGE = gql`
    fragment EmailAutomationSelect on Stage {
        id
        name
        position
    }
`;

// Basic stage query to get all stages by some stagesetId
const GET_STAGES = gql`
    query Stages($stagesetId: ID!) {
        stages(stagesetId: $stagesetId) {
            ...EmailAutomationSelect
        }
    }
    ${STAGE}
`;

class EmailListQuery extends Query<StagesQuery, StagesQueryVariables> {}

export const EmailAutomationSelect = (props: Props) => (
    <EmailListQuery query={GET_STAGES} variables={{stagesetId: props.stagesetId}}>
        {({data, loading}) => {
            const stages = data ? data.stages : null;
            const options = stages ? getValidStagesForSelect(stages, props.stageId) : [];

            if (props.includeUntilClose) {
                const UNTIL_CLOSE_OPTION = {
                    id: SEND_UNTIL_LEAD_CLOSE_MAGIC_ID,
                    name: 'Keep sending until lead closes',
                } as const;
                options.push(UNTIL_CLOSE_OPTION);
            }

            if (props.includeForever) {
                const FOREVER_OPTION = {
                    id: EXITS_STAGE_NEVER_MAGIC_ID,
                    name: 'None - keep sending forever',
                } as const;
                options.push(FOREVER_OPTION);
            }

            return (
                <GraphQLSelect
                    {...props}
                    isLoading={loading}
                    // @ts-expect-error
                    openMenuOnFocus={true}
                    placeholder='Search stages…'
                    models={options}
                />
            );
        }}
    </EmailListQuery>
);
